export type TProductCardStatusComponent = {
  statusType: string
}

export function ProductCardStatusComponent({
  statusType,
}: TProductCardStatusComponent) {
  const status = {
    4: <div className="bg-yellow-300 h-4 w-4 rounded-full" />,
    6: <div className="bg-red-500 h-4 w-4 rounded-full" />,
    12: <div className="bg-green-500 h-4 w-4 rounded-full" />,
  }

  return status[statusType]
}
